// extracted by mini-css-extract-plugin
module.exports = {"ClickButton":"PopForm-2_ClickButton__gc1b8","Header":"PopForm-2_Header__X60Oe"};